import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function BackArrowIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey7', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { d: "M19.152 10.636H8.076l5.045-5.235a.803.803 0 000-1.16.87.87 0 00-1.2 0L5 11.474l6.815 7.284a.86.86 0 00.6.241c.217 0 .434-.08.6-.24a.803.803 0 000-1.162l-4.994-5.32h11.13c.469 0 .849-.368.849-.821 0-.453-.38-.82-.848-.82z", fill: primaryFillColor }) }));
}
//# sourceMappingURL=BackArrow.js.map